"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _reactDom = _interopRequireDefault(require("react-dom"));
var _ownerDocument = _interopRequireDefault(require("dom-helpers/ownerDocument"));
/*
 * FROM https://github.com/react-bootstrap/react-overlays/blob/master/src/utils/ownerDocument.js
 */

function _default(componentOrElement) {
  return componentOrElement && (0, _ownerDocument["default"])(_reactDom["default"].findDOMNode(componentOrElement));
}